import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
export default {
  data: function data() {
    return {
      isShowDELIVERY_NO: true,
      // 输入送货单号
      isShowVENDOR_CODE: true,
      // 输入供应商代码
      isShowVENDOR: true,
      // 输入供应商
      isShowSeach: true,
      // 查询
      isShowAdd: true,
      // 新增
      isShowExport: false,
      // 数据导出
      isShowBlack: false,
      // 返回
      isShowSave: false,
      // 保存
      isShowAddRow: false,
      // 新增明细
      isShowEditOrder: false,
      // 修改明细
      isShowAuditOrder: false,
      // 审核
      isShowUnAuditOrder: false,
      // 反审核
      isShowPrinter: false,
      // 打印
      isShowNext: true,
      // 上一张下一张
      isShowCancellation: false,
      // 作废
      isShowCancel: false,
      // 取消
      isShowSelectOrder: false,
      // 选择送货单
      isCreatePartBarcode: false,
      // 生成标签
      VENDOR_CODE: null,
      // 供应商
      selectLoading: false,
      vendorOptions: [],
      DELIVERY_NO: null,
      // 送货单号
      OrderList: [],
      // 单据列表
      currentIndex: null,
      nextIndex: null,
      orderStatus: null,
      // 单据状态
      orderInfo: {} // 单据内容

    };
  },
  mounted: function mounted() {
    var _this = this;

    this.Bus.on('onClickDELIVERY_NO', function (data, currentIndex, OrderList) {
      // console.log('TabelToolBar---data',data);
      // console.log('TabelToolBar---currentIndex',currentIndex);
      // console.log('TabelToolBar---OrderList',OrderList);
      _this.orderInfo = data;
      _this.OrderList = OrderList;
      _this.currentIndex = currentIndex;

      _this.controlBtnShow(data.STATUS);
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/MaintainDeliveryNote2', ['setOrderStatu'])), {}, {
    // 控制按钮显示
    controlBtnShow: function controlBtnShow(status) {
      if (status === 1) {
        // 未确认
        this.isShowAuditOrder = true;
        this.isShowUnAuditOrder = false;
        this.isShowEditOrder = true;
        this.isShowPrinter = false;
        this.isShowCancellation = true;
      } else if (status === 2) {
        // 已审核
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = true;
        this.isShowPrinter = true;
        this.isShowCancellation = false;
      } else if (status === 3) {
        // 作废
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = false;
        this.isShowPrinter = false;
        this.isShowCancellation = false;
      } else if (status === 4) {
        // 在途
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = true;
        this.isShowPrinter = true;
        this.isShowAuditOrder = false;
        this.isShowCancellation = false;
      } else if (status === 5) {
        // 收货
        this.isShowPrinter = true;
        this.isShowUnAuditOrder = false;
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowCancellation = false;
      } else if (status === 9) {
        // 全关闭
        this.isShowUnAuditOrder = false;
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowPrinter = false;
        this.isShowCancellation = false;
      }
    },
    handleVendorChange: function handleVendorChange() {
      console.log(this.VENDOR_CODE);
    },
    // 点击查询
    handleSearch: function handleSearch() {
      this.Bus.emit('onSearchDeliveryOrder', this.VENDOR_CODE, this.DELIVERY_NO);
    },
    // 点击保存单据
    handleSaveOrder: function handleSaveOrder() {
      // console.log('111', this.MaintainDeliveryNote2OrderState)
      this.$emit('onSave_OuterBoxLabelManagement');

      if (this.MaintainDeliveryNote2OrderState === 'editOrder') {
        this.Bus.emit('onSaveEditOrder');
      } else if (this.MaintainDeliveryNote2OrderState === 'addOrder') {
        this.Bus.emit('onBeforSaveaddOrder');
        console.log(this.mainform);
      }
    },
    // 点击返回
    handleBlackBtn: function handleBlackBtn() {
      // if(this.MaintainDeliveryNote2OrderState !== 'orderShow'){
      //     this.$confirm('返回不会保存已修改的明细, 是否继续?', '提示', {
      //         confirmButtonText: '确定',
      //         cancelButtonText: '取消',
      //         type: 'warning'
      //     }).then(()=>{
      //         this.setOrderStatu('listShow')
      //     }).catch(()=>{
      //         this.$message.warning('已取消')
      //     })
      // }else{
      //     // this.setOrderStatu('listShow')
      //     this.Bus.emit('onHandleBlackForShow')
      // }
      this.Bus.emit('onHandleBlackForShow');
    },
    // 点击取消
    handleCancelBtn: function handleCancelBtn() {
      var _this2 = this;

      if (this.AnnouncementState === 'editOrder') {
        this.$confirm('返回不会保存已修改的明细, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this2.Bus.emit('onAnnouncementCancel');
        }).catch(function () {
          _this2.$message.warning('已取消');
        });
      } else if (this.AnnouncementState === 'addOrder') {
        this.$confirm('返回不会保存已修改的明细, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this2.Bus.emit('onAnnouncementCancel');
        }).catch(function () {
          _this2.$message.warning('已取消');
        });
      }
    },
    // 点击修改
    handleEditOrder: function handleEditOrder() {
      this.Bus.emit('onClickEditOrder');
      this.setOrderStatu('editOrder');
    },
    // 点击新增
    handelAddBtn: function handelAddBtn() {
      this.$emit('AddNotice');
      this.Bus.emit('onClickaddOrder');
      this.setOrderStatu('addOrder');
    },
    saveData: function saveData() {
      console.log(this.mainform);
    }
  }),
  watch: {
    // 公告须知
    AnnouncementState: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态 AnnouncementState==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表
          this.isShowDELIVERY_NO = true;
          this.isShowVENDOR_CODE = true;
          this.isShowVENDOR = true;
          this.isShowSeach = true;
          this.isShowAdd = false;
          this.isShowExport = true;
          this.isShowBlack = false;
          this.isShowSave = false;
          this.isShowAddRow = false;
          this.isShowNext = false;
          this.isShowCancel = false;
          this.isShowSelectOrder = false;
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.isShowDELIVERY_NO = false;
          this.isShowVENDOR_CODE = false;
          this.isShowVENDOR = false;
          this.isShowSeach = false;
          this.isShowAdd = false;
          this.isShowExport = false;
          this.isShowBlack = false;
          this.isShowSave = true;
          this.isShowAddRow = false;
          this.isShowNext = false;
          this.isShowCancel = true;
          this.isShowSelectOrder = false;
          this.isCreatePartBarcode = false;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowDELIVERY_NO = false;
          this.isShowVENDOR_CODE = false;
          this.isShowVENDOR = false;
          this.isShowSeach = false;
          this.isShowAdd = false;
          this.isShowExport = false;
          this.isShowSave = false;
          this.isShowAddRow = false;
          this.isShowCancel = false;
          this.isShowNext = true;
          this.isShowBlack = true;
          this.isShowEditOrder = true;
          this.isShowAuditOrder = true;
          this.isShowCancellation = true;
          this.isCreatePartBarcode = true;
        } else if (nawValue === 'editOrder') {
          this.isShowDELIVERY_NO = false;
          this.isShowVENDOR_CODE = false;
          this.isShowVENDOR = false;
          this.isShowSeach = false;
          this.isShowAdd = false;
          this.isShowExport = false;
          this.isShowNext = false;
          this.isShowEditOrder = false;
          this.isShowAuditOrder = false;
          this.isShowCancellation = false;
          this.isShowBlack = false; // 返回

          this.isShowSave = true; // 保存

          this.isShowAddRow = false; // 新增明细

          this.isShowExport = true; // 数据导出

          this.isShowCancel = true; // 取消
        }
      }
    }
  },
  computed: _objectSpread({}, mapGetters(['AnnouncementState'])),
  beforeDestroy: function beforeDestroy() {
    this.Bus.off('AuditOrderSuccess');
    this.Bus.off('UnCheckBillOrderSuccess');
    this.Bus.off('CancelBillSuccess');
    this.Bus.off('onClickDELIVERY_NO');
  }
};